import { useMutation, useQuery } from "@tanstack/react-query";
import EmployeesService from "@/services/employees/employees.service";
import ChangeRequestService from "@/services/change-request/change-request.service";
import type { PaginatedResponse } from "@/models/responses/base/baseResponse.response";
import type { Employee } from "@/models/responses/employees/employees.response";
import type {
  CreateChangeRequestDto,
  GetChangeRequestsDto,
} from "@/models/dto/change-request.dto";
import type { ChangeRequest } from "@/models/responses/change-request/change-request.response";

export const useGetEmployeesCount = () => {
  return useQuery({
    queryKey: ["employees-count"],
    queryFn: () => EmployeesService.getEmployeesCount(),
  });
};

export const useCreateChangeRequest = () => {
  return useMutation<ChangeRequest, Error, CreateChangeRequestDto>({
    mutationFn: (dto) => ChangeRequestService.createChangeRequest(dto),
  });
};

export const useGetChangeRequests = (dto: GetChangeRequestsDto) => {
  return useQuery<PaginatedResponse<ChangeRequest>>({
    queryKey: ["change-requests", dto],
    queryFn: () => ChangeRequestService.getChangeRequests(dto),
  });
};

export const useGetEmployees = (page: number = 1, limit: number = 10) => {
  return useQuery<PaginatedResponse<Employee>>({
    queryKey: ["employees", page, limit],
    queryFn: () =>
      EmployeesService.getEmployeesList({
        page,
        limit,
      }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
